import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.ProfileSetupForm', {
    profileSetupTitle: "Let's get you set up",
    signupButtonText: 'Complete sign up',
    phoneNumberIsInvalid: 'Phone number is invalid, please check that it has been entered properly.',
    placeholderFirstName: 'First name',
    placeholderLastName: 'Last name',
    placeholderPassword: 'Password',
    qualificationQuestionsAnswersIsInvalid: 'Please complete all the fields in the form',
    consentMarketingText: "I agree to receive ApprovalMax's news, insights and special offers",
    ssoPanelCaption: 'or continue with one of the options',
});
